import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // ─────────────────────────────────────────────
  // No adjuntar token en rutas públicas
  // ─────────────────────────────────────────────

  const publicUrls = ['/auth/login', '/auth/register', '/auth/oauth-user', '/auth/logout'];
  const isPublic = publicUrls.some(url => req.url.includes(url));

  if (isPublic) {
    return next(req);
  }

  // ─────────────────────────────────────────────
  // Adjuntar token JWT a peticiones privadas
  // ─────────────────────────────────────────────

  const token = authService.getToken();

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  // ─────────────────────────────────────────────
  // Manejar errores HTTP
  // ─────────────────────────────────────────────

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // ✅ NUEVO: solo cerrar sesión si el token realmente está expirado
        // evita logout innecesario por errores de red al recargar la página
        const token = authService.getToken();
        if (!token || isTokenExpired(token)) {
          authService.logout();
        }
      }
      return throwError(() => error);
    })
  );
};

// ─────────────────────────────────────────────
// Helper local — evita hacer isTokenExpired público en el service
// ─────────────────────────────────────────────
function isTokenExpired(token: string): boolean {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return true;

    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (payload.length % 4) payload += '=';

    const decoded = JSON.parse(atob(payload));
    if (!decoded.exp) return false;

    return decoded.exp < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
}